import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container text-center mt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Brand", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "lead" }, " Our brand reflects who we are and how we want our users to feel when they use our products. It’s the unique combination of our mission and values, and principles that drive our promise to unleash the potential of every team. ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mt-5" }, "More information will come!", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}